import React, { Component } from 'react';
import { numberWithCommas, makeLinkForQuickbooks } from "../../../common/commonServices";
import Button from '@material-ui/core/Button';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import TextArea from 'antd/lib/input/TextArea';
import './style.css';
import { number } from 'prop-types';
import Switch from '@material-ui/core/Switch';
import { QboSystemAccounts } from '../../../../constants/Enums';

class BalanceSheetNodeComponent extends Component {

    constructor(props) {
        super(props)
        this.Reconciled = React.createRef();
        this.state = {
            lst_data: props.data,
            // lst_quedata: props.quedata,
            level: props.level,
            CollapseGroup: null,
            Expanded: false,
            selectedlevel: -1,
            editedData: null,
            expandedaccount: null,
            ExpandedList: [],
            IsCompared: props.IsCompared
        }
    }

    onRowUpdateClick = () => {
        this.props.UpdateFields(this.state.editedData)
    }

    onRowCancelClick = () => {
        this.setState({ selectedlevel: -1, editedData: null });
    }

    handleFormChange = (e, target) => {
        if (target == "ReconciledThrough") {
            let ed = this.state.editedData;
            ed.ReconciledThrough = e ? new Date(e) : null;
            ed.isReconciledThrough = true;
            this.setState({ editedData: ed })
        }

    }

    handleMessage = (event) => {
        let ed = this.state.editedData;
        ed.Notes = event.target.value;
        this.setState({ editedData: ed });
    }

    handleQuestion = (event) => {
        let ed = this.state.editedData;
        ed.question = event.target.value;
        this.setState({ editedData: ed });
    }

    showChild = (groupName, data, queReport) => {
        if (data.IsData) {

            //let queReport = Object.values(this.state.quedata);
            let item = null;

            // var DataQ = queReport.filter(Q => Q.accountId === data.AccountId)
            // if (DataQ.length > 0) {
            //     item = { AccountId: data.AccountId, ReconciledThrough: (data.ReconciledThrough == "" || data.ReconciledThrough == null) ? null : new Date(data.ReconciledThrough), Notes: data.Notes, questionID: DataQ[0].id, question: DataQ[0].question };
            // } else {
            //     item = { AccountId: data.AccountId, ReconciledThrough: (data.ReconciledThrough == "" || data.ReconciledThrough == null) ? null : new Date(data.ReconciledThrough), Notes: data.Notes, questionID: 0, question: '' };
            // }
            item = { AccountId: data.AccountId, ReconciledThrough: (data.ReconciledThrough == "" || data.ReconciledThrough == null) ? null : new Date(data.ReconciledThrough), Notes: data.Notes, oldOutstandingCount: data.OldOutstandingCount, questionID: data.QuestionId, question: data.Question };

            this.setState({ selectedlevel: data.AccountId, editedData: item });
        }
        else {
            let items = this.state.ExpandedList;
            if (this.IsExpaned(data.Account)) {
                items.splice(items.indexOf(data.Account), 1);
                this.setState({ CollapseGroup: null, Expanded: false, editedData: null, selectedlevel: -1, expandedaccount: data.Account, ExpandedList: items });
            }
            else {
                items.push(data.Account);
                this.setState({ CollapseGroup: groupName, Expanded: true, editedData: null, selectedlevel: -1, expandedaccount: data.Account, ExpandedList: items });
            }
        }
    }

    handleFocus = (e, selecter) => {
        let control = null;
        if (selecter !== undefined) {
            control = this.Reconciled;
            if (control.current != null) {
                control.current.setFocus();
            }
        }
    }

    componentDidMount() {
        let expandedData = this.state.ExpandedList;
        let accounts = this.state.lst_data;
        for (let i = 0; i < accounts.length; i++) {
            if (expandedData.length === 0 || expandedData.indexOf(accounts[i].Account) < 0) {
                expandedData.push(accounts[i].Account);
            }
        }
        this.setState({ ExpandedList: expandedData });
    }


    IsExpaned = (accountName, removed = null, add = null) => {

        return (this.state.ExpandedList.indexOf(accountName) > -1);
    }

    onLinkClick(item) {
        const qboBaseUrl = makeLinkForQuickbooks();
        const url = `${qboBaseUrl}/app/register?accountId=${item.QboAccountId}`;
        window.open(url, '_blank');
    }

    onExcludeReconciliationChange = async (e, item) => {
        e.stopPropagation();
        const isChecked = e.target.checked;
        item.IsExcludedReconciliation = isChecked;
        this.setState({ lst_data: this.state.lst_data });

        const saved = await this.props.excludeReconciliationChange(isChecked, item);
        if (!saved) {
            item.IsExcludedReconciliation = !isChecked;
            this.setState({ lst_data: this.state.lst_data });
        }
    }

    renderExcludeReconciliationCheckbox = (item) => (
        <input className="second-check-box" type="checkbox" checked={item.IsExcludedReconciliation}
            disabled={!this.props.excludeReconciliationChange}
            onClick={(e) => e.stopPropagation()}
            onChange={(e) => this.onExcludeReconciliationChange(e, item)} />
    )

    updateAccountStatus = (e, item) => {
        this.props.accountStatusChange(e, item);
    }

    isSystemAccount = (name, type) => {
        if (!name && !type) return false;

        const systemAccounts = Object.values(QboSystemAccounts);
        const normalizedName = (name || "").toLowerCase().trim();
        const normalizedType = (type || "").toLowerCase().trim();

        return systemAccounts.some(acc =>
            acc.toLowerCase().trim() === normalizedName ||
            acc.toLowerCase().trim() === normalizedType
        );
    };

    // Bank and credit card only (not cash on hand); "-" when unknown (a review saved before the count existed).
    renderOutstandingCount = (item) => {
        if (!item.IsData || (item.Type !== "Bank" && item.Type !== "Credit Card") || item.AccountSubType === "CashOnHand") {
            return null;
        }
        if (item.OldOutstandingTransactionCount == null) {
            return <span>-</span>;
        }
        return item.OldOutstandingTransactionCount > 0
            ? <span className="diff_Amount">{item.OldOutstandingTransactionCount}</span>
            : <span>0</span>;
    };

    renderParentToggle = (item) => {
        if (!item.IsHeader) {
            return null;
        }
        return (
            <span className="bsr-parent-toggle">
                {this.IsExpaned(item.Account)
                    ? <i className="zmdi zmdi-minus-circle-outline" style={{ color: "#349683" }}></i>
                    : <i className="zmdi zmdi-plus-circle-o" style={{ color: "#334c5a" }}></i>}
            </span>
        );
    };

    // Returns only <td> cells so <tr> has no whitespace/"" text-node children
    renderAccountRowCells = (item) => {
        if (item.IsHeader) {
            if (this.state.IsCompared) {
                return (
                    <React.Fragment>
                        <td style={{ paddingLeft: item.level + "0px" }}>
                            <h3>
                                {this.renderParentToggle(item)}
                                {item.Account}
                            </h3>
                        </td>
                        <td className="text-right"> {item.GLBalance != 0 && <span>{numberWithCommas(item.GLBalance)}</span>} </td>
                        <td className="text-right" > {item.Balance != 0 && <span> {numberWithCommas(item.Balance)} </span>} </td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                    </React.Fragment>
                );
            }
            return (
                <React.Fragment>
                    <td style={{ paddingLeft: item.level + "0px" }}>
                        <h3>
                            {this.renderParentToggle(item)}
                            {item.Account}
                        </h3>
                    </td>
                    <td></td>
                    <td className="text-right" > {item.Balance != 0 && <span> {numberWithCommas(item.Balance)} </span>} </td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                </React.Fragment>
            );
        }

        if (item.IsSummary) {
            if (this.state.IsCompared) {
                return (
                    <React.Fragment>
                        <td style={{ paddingLeft: item.level + "0px" }}>
                            <h4 style={{ fontWeight: "500" }}>
                                {this.renderParentToggle(item)}
                                {item.Account}
                            </h4>
                        </td>
                        <td className="text-right"> ${numberWithCommas(item.GLBalance)} </td>
                        <td className="text-right" > {item.Balance != "" ? <span>  ${numberWithCommas(item.Balance)} </span> : <span>$0.00</span>} </td>
                        <td className="text-right"> {item.Balance != item.GLBalance ?
                            <span className="diff_Amount">${numberWithCommas(item.GLBalance - item.Balance)}</span>
                            :
                            null
                        } </td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                    </React.Fragment>
                );
            }
            return (
                <React.Fragment>
                    <td style={{ paddingLeft: item.level + "0px" }}>
                        <h4 style={{ fontWeight: "500" }}>
                            {this.renderParentToggle(item)}
                            {item.Account}
                        </h4>
                    </td>
                    <td></td>
                    <td className="text-right"> ${numberWithCommas(item.Balance)} </td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                </React.Fragment>
            );
        }

        if (item.IsSummary === false && item.IsHeader === false) {
            if (this.state.IsCompared) {
                return (
                    <React.Fragment>
                        <td style={{ paddingLeft: (item.level) + "0px" }}>{item.Account} </td>
                        <td className="text-right">{item.GLBalance != "" ? <span> {numberWithCommas(item.GLBalance)} </span> : <span>0.00</span>}</td>
                        <td className="text-right">{item.Balance != "" ? <span> {numberWithCommas(item.Balance)} </span> : <span>0.00</span>}</td>
                        <td className="text-right">
                            {item.Balance != item.GLBalance ?
                                <span className="diff_Amount">{numberWithCommas(item.GLBalance - item.Balance)}</span>
                                :
                                null
                            }
                        </td>
                        <td className="text-center">{this.renderOutstandingCount(item)}</td>
                        <td className="text-center">
                            {item.AccountId > 0 && this.renderExcludeReconciliationCheckbox(item)}
                        </td>
                        <td className="fixed-col">{item.Notes}</td>
                        <td className="fixed-col">{item.Question}</td>
                        <td className="text-center">
                            {item.Balance == 0 && !this.isSystemAccount(item.Account, item.Type) && (
                                <Switch onClick={(e) => this.updateAccountStatus(e, item)} />
                            )}
                        </td>
                        <td className="text-center">
                            {(item.Balance != 0) && (
                                <img
                                    alt="link"
                                    src="/vendors/grrenLink.png"
                                    onClick={(e) => {
                                        e.stopPropagation();
                                        this.onLinkClick(item);
                                    }}
                                    style={{ cursor: "pointer" }}
                                />
                            )}
                        </td>
                    </React.Fragment>
                );
            }
            return (
                <React.Fragment>
                    <td style={{ paddingLeft: (item.level) + "0px" }}>{item.Account}</td>
                    <td>{item.Type}</td>
                    <td className="text-right">{numberWithCommas(item.Balance)}</td>
                    <td>{item.STRT}</td>
                    <td className="text-center">{this.renderOutstandingCount(item)}</td>
                    <td className="text-center">
                        {item.AccountId > 0 && this.renderExcludeReconciliationCheckbox(item)}
                    </td>
                    <td className="fixed-col">{item.Notes}</td>
                    <td className="fixed-col">{item.Question}</td>
                    <td className="text-center">
                        {item.Balance == 0 && !this.isSystemAccount(item.Account, item.Type) && (
                            <Switch onClick={(e) => this.updateAccountStatus(e, item)} />
                        )}
                    </td>
                    <td className="text-center">
                        {(item.Balance != 0) && (
                            <img
                                alt="link"
                                src="/vendors/grrenLink.png"
                                onClick={(e) => {
                                    e.stopPropagation();
                                    this.onLinkClick(item);
                                }}
                                style={{ cursor: "pointer" }}
                            />
                        )}
                    </td>
                </React.Fragment>
            );
        }

        return null;
    }

    render() {

        const { UpdateFields } = this.props;
        const { accountStatusChange } = this.props;
        return (
            <React.Fragment>
                {(this.state.lst_data.length === 0 && this.state.i === 1) ?
                    <tr>
                        <td colSpan="6">No Data Found!!!</td>
                    </tr>
                    :
                    <React.Fragment>
                        {this.state.lst_data.map((item, i) => (

                            <React.Fragment key={this.state.level + "_" + i} >
                                <tr className={(item.IsHeader) ? item.Account.replace(/\s+/g, '') + "_header" : (item.IsSummary) ? item.Account.replace(/\s+/g, '') + "_total" : ""}
                                    onClick={() => this.showChild(item.Account, item)}>{this.renderAccountRowCells(item)}</tr>
                                {this.state.selectedlevel == item.AccountId &&
                                    <React.Fragment>
                                        <tr className="bs-edit-row">
                                            <td colSpan="3">&nbsp;</td>
                                            <td>
                                                <div>Reconciled Through</div>
                                                <div className="date-box" style={{ border: '1px solid rgb(225, 123, 64)', borderRadius: '6px' }}>
                                                    <DatePicker
                                                        selected={this.state.editedData.ReconciledThrough}
                                                        onChange={(e) => this.handleFormChange(e, 'ReconciledThrough')}
                                                        label="Loan Date"
                                                        id="date"
                                                        name="ReconciledThrough"
                                                        margin="normal"
                                                        disabledKeyboardNavigation
                                                        showMonthDropdown
                                                        showYearDropdown
                                                        yearDropdownItemNumber={15}
                                                        maxDate={new Date()}
                                                        ref={this.Reconciled}
                                                        portalId="bs-datepicker-portal"
                                                        popperPlacement="bottom-start"
                                                        popperModifiers={{
                                                            flip: { enabled: true, behavior: ["bottom-start", "top-start"] },
                                                            preventOverflow: { enabled: true, escapeWithReference: false, boundariesElement: "viewport" }
                                                        }}
                                                    />
                                                    <div className="date-icon" onClick={(e) => this.handleFocus(e, 'ReconciledThrough')}>
                                                        <i className="zmdi zmdi-calendar-note"></i>
                                                    </div>
                                                </div>

                                            </td>
                                            <td></td>
                                            <td>
                                                Internal Notes :
                                                <TextArea placeholder="Enter Notes" onChange={this.handleMessage} value={this.state.editedData.Notes} className="textarea-box" >
                                                </TextArea>
                                                <div style={{ padding: "10px" }}>
                                                    <Button className="jr-btn jr-btn-sm bg-teal text-white" onClick={() => this.onRowUpdateClick()}>SAVE</Button>
                                                    <Button className="jr-btn jr-btn-sm bg-danger text-white" onClick={() => this.onRowCancelClick()}>CANCEL</Button>
                                                </div>
                                            </td>
                                            <td>
                                                Questions and Comments for the Client:
                                                <TextArea placeholder="Enter Questions" onChange={this.handleQuestion} value={this.state.editedData.question} className="textarea-box" >
                                                </TextArea>
                                            </td>
                                        </tr>
                                    </React.Fragment>
                                }
                                {item.Items.length > 0 &&
                                    this.IsExpaned(item.Account)
                                    && <BalanceSheetNodeComponent
                                        data={item.Items}
                                        level={this.state.level + 1}
                                        UpdateFields={UpdateFields}
                                        accountStatusChange={accountStatusChange}
                                        excludeReconciliationChange={this.props.excludeReconciliationChange}
                                        IsCompared={this.state.IsCompared}
                                    >
                                    </BalanceSheetNodeComponent>
                                }
                            </React.Fragment>
                        ))}
                    </React.Fragment>
                }
            </React.Fragment>
        )
    }
}


export default BalanceSheetNodeComponent;
